<!-- ═══════════════════════════════════════════════════════════════════════
     HERO SECTION — Refonte moderne
     Layout : split (texte gauche + carte articles droite)
     ═══════════════════════════════════════════════════════════════════════ -->
<section class="arp-hero" [class.arp-hero--rtl]="currentLang() === 'ar'">

  <!-- Couches de fond -->
  <div class="arp-hero__bg"></div>
  <div class="arp-hero__glow arp-hero__glow--a"></div>
  <div class="arp-hero__glow arp-hero__glow--b"></div>
  <div class="arp-hero__grid-pattern"></div>

  <div class="container">
    <div class="arp-hero__inner">

      <!-- ── Colonne gauche : texte + CTA ── -->
      <div class="arp-hero__main">

        <span class="arp-hero__badge" style="display: none !important;">
          <span class="arp-hero__badge-dot"></span>
          {{ 'Autorité de Régulation de la Publicité' | translate }}
        </span>

        <!-- Carrousel de titres (fade) -->
        <div class="arp-hero__slider"
             *ngIf="heros.length; else heroFallback">
          <ng-container *ngFor="let s of heros; let i = index; trackBy: trackByID">
            <div class="arp-hero__slide" [class.is-active]="i === activeIndex()">
              <h1 class="arp-hero__title" [innerHTML]="translateField(s.title)"></h1>
              <p class="arp-hero__text" [innerHTML]="translateField(s.content)"></p>
            </div>
          </ng-container>
        </div>

        <ng-template #heroFallback>
          <h1 class="arp-hero__title">
            {{ "Pour une publicité responsable et transparente" | translate }}
          </h1>
          <p class="arp-hero__text">
            {{ "L'Autorité de Régulation de la Publicité veille au respect des règles éthiques et juridiques en Mauritanie." | translate }}
          </p>
        </ng-template>

        <!-- CTA principaux -->
        <div class="arp-hero__cta">
          <a [routerLink]="['/annuaire']" class="arp-hero__btn arp-hero__btn--primary">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
              <circle cx="11" cy="11" r="7"/><path d="M21 21l-4.35-4.35" stroke-linecap="round"/>
            </svg>
            <span>{{ 'agrees' | translate }}</span>
          </a>
          <a [routerLink]="['/articles']" class="arp-hero__btn arp-hero__btn--ghost">
            <span>{{ 'Actualités' | translate }}</span>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
              <path d="M5 12h14M13 5l7 7-7 7" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </a>
        </div>

        <!-- Pagination dots + contrôles -->
        <div class="arp-hero__controls" *ngIf="heros.length > 1">
          <button type="button"
                  class="arp-hero__nav"
                  (click)="prev()"
                  [attr.aria-label]="'Précédent'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M15 19l-7-7 7-7" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>

          <div class="arp-hero__dots">
            <button *ngFor="let s of heros; let i = index"
                    type="button"
                    class="arp-hero__dot"
                    [class.is-active]="i === activeIndex()"
                    (click)="goTo(i)"
                    [attr.aria-label]="'Slide ' + (i + 1)"></button>
          </div>

          <button type="button"
                  class="arp-hero__nav"
                  (click)="next()"
                  [attr.aria-label]="'Suivant'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M9 5l7 7-7 7" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </div>

      <!-- ── Colonne droite : carte articles (herovisual) ── -->
      <aside class="arp-hero__aside">
        <app-herovisual [postsData]="latestArticles"></app-herovisual>
      </aside>

    </div>
  </div>
</section>
